import { Heart, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CEO_URL } from "@/config";

export const CeoSection = () => (
  <section id="ceo" data-testid="ceo-section" className="relative overflow-hidden bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 md:px-8 lg:grid-cols-12">
      <div className="relative lg:col-span-5">
        <Reveal className="relative">
          <div className="relative overflow-hidden rounded-[2.5rem] bg-hope-green shadow-md">
            <span className="pointer-events-none absolute inset-x-0 top-8 select-none text-center font-heading text-8xl font-black tracking-tighter text-white/10">
              HOPE
            </span>
            <img
              src={CEO_URL}
              alt="The CEO of Hope Restored Missions running in her 2Run4Hope race gear"
              data-testid="ceo-image"
              className="relative mx-auto max-h-[560px] w-auto object-contain pt-14"
            />
          </div>
          <div
            data-testid="ceo-badge"
            className="absolute -bottom-5 left-6 flex items-center gap-2 rounded-full bg-hope-red px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-white shadow-lg"
          >
            <Heart className="h-4 w-4" />
            She runs too
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <p data-testid="ceo-overline" className="mb-4 text-sm font-semibold uppercase tracking-[0.3em] text-hope-green">
            Meet Our CEO
          </p>
          <h2
            data-testid="ceo-heading"
            className="font-heading text-4xl font-black leading-[1.05] tracking-tighter text-hope-ink sm:text-5xl lg:text-6xl"
          >
            The Heart Behind
            <br />
            the Mission<span className="text-hope-red">.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <blockquote className="relative mt-10 max-w-2xl">
            <Quote className="absolute -left-2 -top-3 h-10 w-10 text-hope-green/15" />
            <p
              data-testid="ceo-quote"
              className="pl-8 font-heading text-2xl font-bold leading-snug text-hope-ink md:text-3xl"
            >
              Every person who laces up for 2Run4Hope becomes part of someone's
              comeback story. We don't just run for finish lines — we run so
              families in crisis can find their way home. I can't wait to see
              you at the start line.
            </p>
            <footer className="mt-6 pl-8">
              <p data-testid="ceo-attribution" className="text-sm font-bold uppercase tracking-[0.2em] text-hope-green">
                Dr. Tamara Monroe
              </p>
              <p className="mt-1 text-sm text-zinc-500">
                CEO, Hope Restored Missions — founder, race-day pacer, and first
                to high-five you at the finish
              </p>
            </footer>
          </blockquote>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-zinc-600 md:text-lg">
            Under her leadership, Hope Restored Missions has grown from a
            neighborhood meal program into a lifeline of transitional housing
            and crisis resources for families across our community — and yes,
            she'll be running the 5K right alongside you on November 21.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
